<template>
  <div class="ec-exchange">
    <div class="ec-exchange__head">
      <div class="ec-exchange__button" @click="handleChange">
        <div class="ec-exchange__txt">切换</div>
        <i class="el-icon-sort"></i>
      </div>
    </div>
    <div class="ec-exchange__content">
      <div class="ec-exchange__item"
        key="content1"
        v-if="activeContent == 'content1'">
          <slot name="content1">
          </slot>
      </div>
      <div class="ec-exchange__item"
        key="content2"
        v-if="activeContent == 'content2'">
        <slot name="content2">
        </slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'EcExchange',
  data () {
    return {
      activeContent: this.active
    }
  },
  props: {
    active: {
      type: String,
      default: 'content1'
    }
  },
  methods: {
    handleChange () {
      this.activeContent = this.activeContent == 'content1' ? 'content2' : 'content1'
      this.$emit('change', this.activeContent)
    }
  }
}
</script>
<style scoped lang="scss">
.ec-exchange {
  &__head {
    text-align: right;
    position: absolute;
    right: 10px;
    color: #409eff;
    z-index: 1000;
    border-radius: 100%;
    text-align: center;
    .el-icon-sort {
      transform: rotate(90deg);
    }
    :hover {
      cursor: pointer;
    }
  }
  &__button {
    display: inline-block;
    padding: 2px 2px 1px 1px;
  }
  &__txt {
    font-size: 12px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/EcExchange/src/index.vue